import { required } from "vuelidate/lib/validators";
import {ModelObject} from "@/pages/Common/modelObject";

export const NewsStatus = Object.freeze({
    DRAFT: 1,
    READY_FOR_MODERATION: 2,  // убрали из БД
    MODERATED: 3,
    PUBLISHED: 4,
    DECLINED: 5,
});


export const NEWS_STATUS = {
    [NewsStatus.DRAFT]: 'Черновик',
    [NewsStatus.READY_FOR_MODERATION]: 'Ждет проверки', // убрали из БД
    [NewsStatus.MODERATED]: 'Ожидает публикации',
    [NewsStatus.PUBLISHED]: 'Опубликовано',
    [NewsStatus.DECLINED]: 'Проверка не пройдена'
}

export class News extends ModelObject {
    constructor(initObjectParams) {
        super(initObjectParams);
        // поля формы
        this.id = null;
        this.status = NewsStatus.DRAFT;
        this.title = null;
        this.preview = null;
        this.body = null;
        this.publicationDate = null;
        this.lastReviewedAt = null;
        this.reviewComment = null;
        this.authorOrganizationName = null;

        this.attachments = [];

        this.applyInitObjectParams(initObjectParams);
    }

    static get modelName() {
        return 'News'
    }

    static get validations() {
        return {
            status: {},
            title: {required},
            preview: {},
            body: {},
            attachments: {},
            reviewComment: {}
        }
    }

    static get validationFieldLabels() {
        return {
            title: 'Заголовок',
            preview: 'Первый абзац',
            body: 'Текст',
            reviewComment: 'Комментарий',
            lastReviewedAt: 'Дата последней проверки'
        }
    }

    static get mapping() {
        return {
            publicationDate: 'publication_date',
            reviewComment: 'review_comment'
        }
    }

    static get label() {
        return 'Новость'
    }

    label() {
        return 'Новость'
    }

    static get newLabel() {
        return 'Новая новость'
    }

    objectLabel() {
        return this.title
    }

    get statusText() {
        return NEWS_STATUS[this.status]
    }

    _dateStrComponents(date, index) {
        if (date) {
            const components = date.split(' ')
            if (components.length && components.length > index) {
                return components[index]
            }
        }
        return ''
    }

    get pubDateStr() {
        return this._dateStrComponents(this.publicationDate, 0)
    }

    get pubTimeStr() {
        return this._dateStrComponents(this.publicationDate, 1)
    }

    get lastReviewedAtDateStr() {
        return this._dateStrComponents(this.lastReviewedAt, 0)
    }

    get lastReviewedAtTimeStr() {
        return this._dateStrComponents(this.lastReviewedAt,1)
    }


    applyData(data) {
        super.applyData(data);
    }
}
